import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "../components/layout/SiteLayout";

export default function NotFoundPage() {
  useEffect(() => {
    document.title = "페이지를 찾을 수 없습니다 | kwangbok.me";
  }, []);

  return (
    <SiteLayout crumb="404">
      <div className="card notfound">
        <span className="eyebrow">404 Not Found</span>
        <h1>페이지를 찾을 수 없습니다</h1>
        <p className="muted">주소가 바뀌었거나 없는 페이지입니다.</p>
        <p className="notfound-links">
          <Link to="/" className="chip">홈으로</Link>
          <Link to="/apps" className="chip">앱 목록</Link>
        </p>
      </div>
    </SiteLayout>
  );
}
